// This file is auto-generated by @hey-api/openapi-ts

import type { Options as ClientOptions, TDataShape, Client } from './client';
import type { HeadHealthCheckData, HeadHealthCheckResponses, GetApiCommonShutdownData, GetApiCommonShutdownResponses, PostApiCommonShutdownData, PostApiCommonShutdownResponses, HeadApiCommonHealthCheckData, HeadApiCommonHealthCheckResponses, GetApiGameInitData, GetApiGameInitResponses, PostApiGameStartData, PostApiGameStartResponses, PostApiGameBetData, PostApiGameBetResponses, PostApiGameFastBetData, PostApiGameFastBetResponses, PostApiGameCashoutData, PostApiGameCashoutResponses, GetApiGameCheckData, GetApiGameCheckResponses, HeadApiGameHealthCheckData, HeadApiGameHealthCheckResponses } from './types.gen';
import { client as _heyApiClient } from './client.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

export const headHealthCheck = <ThrowOnError extends boolean = false>(options?: Options<HeadHealthCheckData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).head<HeadHealthCheckResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/health-check',
        ...options
    });
};

export const getApiCommonShutdown = <ThrowOnError extends boolean = false>(options?: Options<GetApiCommonShutdownData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetApiCommonShutdownResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/Common/shutdown',
        ...options
    });
};

export const postApiCommonShutdown = <ThrowOnError extends boolean = false>(options?: Options<PostApiCommonShutdownData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<PostApiCommonShutdownResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/Common/shutdown',
        ...options
    });
};

export const headApiCommonHealthCheck = <ThrowOnError extends boolean = false>(options?: Options<HeadApiCommonHealthCheckData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).head<HeadApiCommonHealthCheckResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/Common/health-check',
        ...options
    });
};

export const getApiGameInit = <ThrowOnError extends boolean = false>(options: Options<GetApiGameInitData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiGameInitResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/Game/init',
        ...options
    });
};

export const postApiGameStart = <ThrowOnError extends boolean = false>(options?: Options<PostApiGameStartData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<PostApiGameStartResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/Game/start',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const postApiGameBet = <ThrowOnError extends boolean = false>(options?: Options<PostApiGameBetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<PostApiGameBetResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/Game/bet',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const postApiGameFastBet = <ThrowOnError extends boolean = false>(options?: Options<PostApiGameFastBetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<PostApiGameFastBetResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/Game/fast-bet',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const postApiGameCashout = <ThrowOnError extends boolean = false>(options?: Options<PostApiGameCashoutData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<PostApiGameCashoutResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/Game/cashout',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const getApiGameCheck = <ThrowOnError extends boolean = false>(options: Options<GetApiGameCheckData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiGameCheckResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/Game/check',
        ...options
    });
};

export const headApiGameHealthCheck = <ThrowOnError extends boolean = false>(options?: Options<HeadApiGameHealthCheckData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).head<HeadApiGameHealthCheckResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-Api-Key',
                type: 'apiKey'
            }
        ],
        url: '/api/Game/health-check',
        ...options
    });
};